/**
 * ============================================================
 * MONTE HERMOM | PAINEL OPERACIONAL SaaS
 * ============================================================
 * ARQUIVO: /src/components/dashboard/DashBoardSaaS_Amber.jsx
 * VERSÃO:  4.0.0 — Modelo SaaS Operacional
 * ============================================================
 */

import React from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";

// Cards operacionais
import IndicadoresCards     from "./cards/IndicadoresCards";
import ProducaoCard         from "./cards/ProducaoCard";
import AtencaoAgoraCard     from "./cards/AtencaoAgoraCard";
import VistoriasCard        from "./cards/VistoriasCard";
import PendenciasCard       from "./cards/PendenciasCard";
import TimelineOperacional  from "./cards/TimelineOperacional";

export default function DashBoardSaaS_Amber({ usuario }) {
  const navigate = useNavigate();

  return (
    <div className="p-8 space-y-8 max-w-[1600px] mx-auto">

      {/* ================= HEADER ================= */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-black uppercase tracking-tight text-white">
            Painel Operacional
          </h1>
          <p className="text-xs text-slate-400 mt-1">
            Visão geral da produção pericial — Bem-vindo, {usuario?.nome || 'Perito'}
          </p>
        </div>

        <button
          onClick={() => navigate('/laudos/novo')}
          className="flex items-center gap-2 px-5 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white text-[11px] font-bold uppercase tracking-widest shadow-lg shadow-blue-500/20 transition-all"
        >
          <Plus size={14} />
          Novo Laudo
        </button>
      </div>

      {/* ================= INDICADORES ================= */}
      <IndicadoresCards />

      {/* ================= LINHA 1: PRODUÇÃO + ATENÇÃO ================= */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <ProducaoCard />
        </div>
        <div className="lg:col-span-1">
          <AtencaoAgoraCard />
        </div>
      </div>

      {/* ================= LINHA 2: VISTORIAS + PENDÊNCIAS ================= */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <VistoriasCard />
        <PendenciasCard />
      </div>

      {/* ================= LINHA 3: TIMELINE ================= */}
      <TimelineOperacional />

    </div>
  );
}